var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotifications(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1980_6508",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1980_6508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.33398 25.3346V22.668H8.00065V13.3346C8.00065 11.4902 8.55621 9.8513 9.66732 8.41797C10.7784 6.98463 12.2229 6.04575 14.0007 5.6013V4.66797C14.0007 4.11241 14.1951 3.64019 14.584 3.2513C14.9729 2.86241 15.4451 2.66797 16.0007 2.66797C16.5562 2.66797 17.0284 2.86241 17.4173 3.2513C17.8062 3.64019 18.0007 4.11241 18.0007 4.66797V5.6013C19.7784 6.04575 21.2229 6.98463 22.334 8.41797C23.4451 9.8513 24.0007 11.4902 24.0007 13.3346V22.668H26.6673V25.3346H5.33398ZM16.0007 29.3346C15.2673 29.3346 14.6395 29.0735 14.1173 28.5513C13.5951 28.0291 13.334 27.4013 13.334 26.668H18.6673C18.6673 27.4013 18.4062 28.0291 17.884 28.5513C17.3618 29.0735 16.734 29.3346 16.0007 29.3346Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications);
export default __webpack_public_path__ + "static/media/notifications.6f8504b6b7095df83daba46d84d3a2b1.svg";
export { ForwardRef as ReactComponent };